import { Component, Fragment } from "react";
import { Trans, useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  BorrowControllerApi,
  GetMyBookshelfUsingPOSTRequest,
  MyBookshelfDto,
  BorrowDto
} from "../../../fetcher";
import { handleUserInfo } from "../../../redux/actions/userInfo";
import * as PATH from "../../../utils/Contants";
import { DIALOG_CANCEL, DIALOG_COMPLETE } from "../../../utils/Contants";
import { genApiConfig } from "../../../utils/fetch-caller";
import style from "./BookShelf.module.css";
import BookShelfItem from "./BookShelfItem";

import { ISocketMsg } from "../../../utils/socket/types";

interface IProps {
  title?: string;
  content?: string;
  value?: string;
  callBack?: (value: any, value2?: any) => void;
  styleType?: string;
  children?: any;
  navigate?: any;
  userInfo?: any;
  socketMsg?: ISocketMsg;
  setDetailPage?: (data: string) => void;
  setBookPage?: (data: string) => void;
  sessionId?: string;
  memberId?: number;
}

interface IState {
  content: any;
  title: string;
  showError: boolean;
  loading: boolean;
  borrowBook: BorrowDto[];
}

class BookShelf extends Component<IProps, IState> {
  state: IState = {
    content: {},
    title: "",
    showError: false,
    loading: false,
    borrowBook: [],
  };

  componentDidMount() {
    console.log('BookShelf componentDidMount - userInfo:', this.props.userInfo);
    if (Object.keys(this.props.userInfo?.userInfo).length > 0) {
      this.getApi();
    }
  }

  getApi() {
    console.log('BookShelf getApi - Getting data for member:', 
      this.props.userInfo?.userInfo.member.memberId
    );

    new BorrowControllerApi(genApiConfig())
      .getMyBookshelfUsingPOST({
        memberId: this.props.userInfo?.userInfo.member.memberId,
      } as GetMyBookshelfUsingPOSTRequest)
      .then((res: MyBookshelfDto) => {
        console.log('BookShelf - Received bookshelf data:', res);
        this.setState(
          { ...this.state, borrowBook: res.borrow?.slice(0, 5) || [] },
          () => {
            console.log('BookShelf - Updated state with books:', this.state.borrowBook);
          }
        );
      })
      .catch((err) => {
        console.error('BookShelf - Error getting bookshelf:', err);
      });
  }

  handleCancel = () => {
    this.props.callBack?.({ action: DIALOG_CANCEL });
  };

  handleSubmit = () => {
    this.props.callBack?.({ action: DIALOG_COMPLETE });
  };

  render() {
    const { content, showError, loading } = this.state;

    return (
      <Fragment>
        <div
          style={{ marginTop: "2em" }}
          className={style.tableItemListContainer}
        >
          <div className={style.tableListItemGridView}>
            <div className={style.topRow}></div>

            <div className={style.content}>
              <div className={style.padding}>
                <div className={style.title}>
                  <h3>
                    <Trans>Shelf</Trans>
                  </h3>
                  <div
                    className={style.btn}
                    onClick={() => this.props.navigate(PATH.MYBOOKSHELF)}
                  >
                    <Trans>showMore</Trans>
                  </div>
                </div>
                <div className={style.scrollingWrapper}>
                  {this.state.borrowBook.map((obj: BorrowDto) => {
                    console.log('BookShelf - Rendering BookShelfItem:', {
                      bookId: obj.productId,
                      bookName: obj.bookname
                    });
                    return (
                      <BookShelfItem
                        key={obj.productId}
                        it={obj}
                        callBack={(value) => this.getApi()}
                        socketMsg={this.props.socketMsg}
                        setDetailPage={this.props.setDetailPage}
                        setBookPage={this.props.setBookPage}
                        sessionId={this.props.sessionId}
                        memberId={this.props.memberId}
                      ></BookShelfItem>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    userInfo: state.userInfo,
  };
};
const actionCreator = {
  handleUserInfo,
};

export default connect(mapStateToProps, actionCreator)(BookShelf);
